import { BaseModel } from './BaseModel';
import { Server } from './Server';

export interface MapRotationMap {
    id: string;
    sequence: number;
    size: number | null;
    seed: string | null;
    randomSeed: boolean;
    randomLevel: boolean;
    customUrl: string | null;
    lastUsedAt: string | null;
}

export class MapRotation extends BaseModel {
    public id = -1;
    public serverId = '';
    public name = '';
    public description = '';
    public isActive = false;
    public nextChangeAt = '';
    public lastChangeAt = '';
    public isProcessing = false;
    public isRotating = false;
    public rotationIntervalDays = 0;
    public createdAt = '';
    public updatedAt = '';

    get server(): Server {
        return this.getRelationship('server');
    }

    get maps(): MapRotationMap[] {
        return this.getRelationship('maps') || [];
    }

    getRouteName() {
        return 'map_rotation';
    }

    getRouteID() {
        return this.id.toString();
    }
}
